"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _queue, _maxFrames, _framesSilence, _underrunCount, _currentFrames;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleOutputAudioQueue = exports.OutputAudioQueueBase = exports.populateQuantumWith = void 0;
const BufferConditionReporter_1 = require("./BufferConditionReporter");
const debug_1 = __importDefault(require("debug"));
const debugNamespace = 'vxt:rtc:audiobuffer';
const debug = debug_1.default(debugNamespace);
function populateQuantumWith(src, dst) {
    const channels = src.length;
    const length = src[0].length;
    for (let ch = 0; ch < channels; ch++) {
        const srcBuf = src[ch];
        const dstBuf = dst[ch];
        dstBuf.set(srcBuf);
    }
}
exports.populateQuantumWith = populateQuantumWith;
class OutputAudioQueueBase {
    constructor(reportingCallback) {
        debug.enabled = debug.enabled || debug_1.default.enabled(debugNamespace);
        this.underrunReporter = new BufferConditionReporter_1.UnderrunReporter(reportingCallback, debug);
        this.overrunReporter = new BufferConditionReporter_1.OverrunReporter(reportingCallback, debug);
    }
}
exports.OutputAudioQueueBase = OutputAudioQueueBase;
class SimpleOutputAudioQueue extends OutputAudioQueueBase {
    constructor(sampleRate, latency, reportingCallback) {
        super(reportingCallback);
        _queue.set(this, void 0);
        _maxFrames.set(this, void 0);
        _framesSilence.set(this, void 0);
        _underrunCount.set(this, 0);
        _currentFrames.set(this, void 0);
        __classPrivateFieldSet(this, _maxFrames, Math.round(sampleRate * latency));
        __classPrivateFieldSet(this, _framesSilence, __classPrivateFieldGet(this, _maxFrames));
        __classPrivateFieldSet(this, _currentFrames, __classPrivateFieldGet(this, _maxFrames));
        __classPrivateFieldSet(this, _queue, []);
    }
    pull(toPopulate) {
        if (__classPrivateFieldGet(this, _framesSilence) >= toPopulate[0].length) {
            __classPrivateFieldSet(this, _framesSilence, __classPrivateFieldGet(this, _framesSilence) - toPopulate[0].length);
            __classPrivateFieldSet(this, _currentFrames, __classPrivateFieldGet(this, _currentFrames) - toPopulate[0].length);
            return null;
        }
        else if (__classPrivateFieldGet(this, _queue).length === 0) {
            __classPrivateFieldSet(this, _underrunCount, +__classPrivateFieldGet(this, _underrunCount) + 1);
            this.underrunReporter.tick(true);
            return null;
        }
        else {
            const signal = __classPrivateFieldGet(this, _queue).shift();
            __classPrivateFieldSet(this, _currentFrames, __classPrivateFieldGet(this, _currentFrames) - signal[0].length);
            populateQuantumWith(signal, toPopulate);
            this.underrunReporter.tick(false);
            return signal;
        }
    }
    push(quantum) {
        if (__classPrivateFieldGet(this, _underrunCount) === 0) {
            const newFrames = quantum[0].length;
            if (__classPrivateFieldGet(this, _currentFrames) + newFrames > __classPrivateFieldGet(this, _maxFrames) && __classPrivateFieldGet(this, _queue).length > 0) {
                this.overrunReporter.tick(true);
            }
            else {
                __classPrivateFieldGet(this, _queue).push(quantum);
                __classPrivateFieldSet(this, _currentFrames, __classPrivateFieldGet(this, _currentFrames) + newFrames);
                this.overrunReporter.tick(false);
            }
        }
        else {
            this.overrunReporter.tick(false);
            __classPrivateFieldSet(this, _underrunCount, +__classPrivateFieldGet(this, _underrunCount) - 1);
        }
    }
    clear() {
        __classPrivateFieldSet(this, _underrunCount, 0);
        __classPrivateFieldGet(this, _queue).length = 0;
        __classPrivateFieldSet(this, _framesSilence, __classPrivateFieldGet(this, _maxFrames));
        __classPrivateFieldSet(this, _currentFrames, __classPrivateFieldGet(this, _maxFrames));
    }
}
exports.SimpleOutputAudioQueue = SimpleOutputAudioQueue;
_queue = new WeakMap(), _maxFrames = new WeakMap(), _framesSilence = new WeakMap(), _underrunCount = new WeakMap(), _currentFrames = new WeakMap();
